import { render, staticRenderFns } from "./parts.vue?vue&type=template&id=7ffe4406&scoped=true&"
import script from "./parts.vue?vue&type=script&lang=ts&"
export * from "./parts.vue?vue&type=script&lang=ts&"
import style0 from "./parts.vue?vue&type=style&index=0&id=7ffe4406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe4406",
  null
  
)

export default component.exports